// 日志级别
export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
}

// 当前环境
declare const process: {
  env: {
    VUE_APP_API_URL: string;
    VUE_APP_DEBUG: string;
    VUE_APP_LOG_LEVEL: string;
    [key: string]: string | undefined;
  };
};

// 获取环境变量中的日志级别，如果未设置则根据调试模式决定
const getLogLevel = () => {
  const logLevel = process.env.VUE_APP_LOG_LEVEL;
  if (logLevel) {
    switch (logLevel.toUpperCase()) {
      case "DEBUG":
        return LogLevel.DEBUG;
      case "INFO":
        return LogLevel.INFO;
      case "WARN":
        return LogLevel.WARN;
      case "ERROR":
        return LogLevel.ERROR;
      default:
        return LogLevel.INFO; // 默认使用 INFO 级别
    }
  }
  // 如果未设置日志级别，则根据调试模式决定
  return process.env.VUE_APP_DEBUG === "true" ? LogLevel.DEBUG : LogLevel.INFO;
};

const currentLogLevel = getLogLevel();

export const logger = {
  debug: (...args: unknown[]) => {
    if (currentLogLevel <= LogLevel.DEBUG) {
      console.log(...args);
    }
  },

  info: (...args: unknown[]) => {
    if (currentLogLevel <= LogLevel.INFO) {
      console.info(...args);
    }
  },

  warn: (...args: unknown[]) => {
    if (currentLogLevel <= LogLevel.WARN) {
      console.warn(...args);
    }
  },

  error: (...args: unknown[]) => {
    if (currentLogLevel <= LogLevel.ERROR) {
      console.error(...args);
    }
  },
};
